import { StoreState } from "~/redux/reducers";

export const selectStatusHoverPosition = (state: StoreState) =>
  state.status.hoverPosition;

export const selectStatusSelectedAutostoreGridId = (state: StoreState) =>
  state.status.selectedAutostoreGridId;
